import { render } from "./PrivacyPolicyOnly.vue?vue&type=template&id=015a51e2&scoped=true"
import script from "./PrivacyPolicyOnly.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyOnly.vue?vue&type=script&lang=js"

import "./PrivacyPolicyOnly.vue?vue&type=style&index=0&id=015a51e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015a51e2"]])

export default __exports__